<div class="col-12 col-md-4 mx-auto px-2 text-center">
  <div class="container" *ngIf="disableFormPhone">
    <div class="row">
      <div class="col-12 col-md-12">
        <img src="../../../assets/logo/icon-192x172.png" class="img-fluid" alt="...">
      </div>
      <div class="col-12 col-md-12">
        <p><b>Bantu kami tingkatkan kualitas layanan dan produk!</b></p><br>
        <p>Sudah lama Anda tidak berbelanja di PEDRO lagi sejak terakhir Anda terdaftar sebagai VIP Member PEDRO.</p>
        <p>Kami ingin mendengar dari Anda dan <br> Ingin lebih memahami preferensi Anda.</p>
        <p>
          Sebagai apresiasi atas waktu yang Anda luangkan untuk menjawab 9
          pertanyaan, Anda akan mendapatkan 20% diskon untuk satu produk
          favorit Anda di PEDRO.
        </p>
      </div>
      <div class="col-12 col-md-12 pt-4 p-4 pb-5">
        <div class="row" style="place-content: center;">
          <div class="col-6 col-md-6">
            <form [formGroup]="formAuth">
              <!-- <input type="text" formControlName="phone" class="form-control " id="phone" placeholder="*Nomor Handphone"> -->
              <input type="text" id="disabledTextInput"
              class="form-control {{formAuth.get('phone')!.hasError('required') && (formAuth.get('phone')!.dirty || formAuth.get('phone')!.touched) ? 'is-invalid' : ''}}"
              placeholder="*Nomor Handphone" formControlName="phone" autocomplete="off">
              <div *ngFor="let error of errorMessages.phone">
                <ng-container
                  *ngIf="formAuth.get('phone')!.hasError(error.type) && (formAuth.get('phone')!.dirty || formAuth.get('phone')!.touched)">
                  <small class="error-message" style="font-size: 10px !important;">{{error.message}}</small>
                </ng-container>
              </div>
              <div *ngIf="errorPhoneNumber">
                <small class="error-message" style="font-size: 10px !important;">{{errorPhoneNumber}}</small>
              </div>
            </form>
          </div>
          <div *ngIf="errorMessageOtp">
            <small class="error-message" style="font-size: 10px !important; color:red;">{{errorMessageOtp}}</small>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-12 pt-5 p-5">
        <div class="row">
          <div class="col-6 col-md-6">
            <button (click)="onPreviousPage('./')" class="btn btn-dark btn-sm bTc" type="button">
              <i class="bi bi-chevron-left"></i>
            </button>
          </div>
          <div class="col-6 col-md-6">
            <ng-container *ngIf="isLoading;else onFilters">
              <button class="btn btn-dark" type="button" disabled>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              </button>
            </ng-container>
            <ng-template #onFilters>
              <button (click)="onNextPage('sendOTP')" class="btn btn-dark btn-sm bTc" type="button" [disabled]="!formAuth.valid">
                <i class="bi bi-chevron-right"></i>
              </button>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- kasih !disableFormPhone -->
  <div class="container" *ngIf="!disableFormPhone && disableFormOtp ">
    <div class="row">
      <div class="col-12 col-md-12 pb-5" style="text-align: end;">
        <img src="../../../assets/logo/header.png" class="img-fluid" alt="...">
      </div>
    </div>
    <div class="row py-5">
      <div class="col-12 col-md-12 pt-5">
        <p><b>Kode OTP telah dikirimkan ke nomor Anda via WhatsApp.
          Mohon masukkan kode tersebut ke kolom di bawah ini:</b></p><br>
      </div>
      <div class="col-12 col-md-12 pt-4 p-4 pb-5">
        <div class="row" style="place-content: center;">
          <div class="col-6 col-md-6">
            <form [formGroup]="formAuthOTP">
              <input type="text" formControlName="otp" class="form-control " id="phone" placeholder="Kode OTP">
              <div *ngIf="errorOTP">
                <small class="error-message" style="font-size: 10px !important;">{{errorOTP}}</small>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-12 pt-5 px-2">
        <div class="row">
          <div class="col-6 col-md-6 text-start">
            <button (click)="onPreviousPage('./')" class="btn btn-dark btn-sm bTc" type="button">
              <i class="bi bi-chevron-left"></i>
            </button>
          </div>
          <div class="col-6 col-md-6 text-end">
            <ng-container *ngIf="isLoading;else onFilters">
              <button class="btn btn-dark" type="button" disabled>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              </button>
            </ng-container>
            <ng-template #onFilters>
              <button (click)="onNextPage('kodeOTP')" class="btn btn-dark btn-sm bTc" type="button" [disabled]="!formAuthOTP.valid">
                <i class="bi bi-chevron-right"></i>
              </button>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container" *ngIf="!disableFormOtp">
    <div class="row">
      <div class="col-12 col-md-12 pb-2" style="text-align: end;">
        <img src="../../../assets/logo/header.png" class="img-fluid" alt="...">
      </div>
    </div>

    <div class="row py-5">
      <div class="col-12 col-md-12 pt-5">
        <p><b>Nama</b></p>
        <p>{{dataVipMember.nama}}</p><br>
        <p><b>Alamat</b></p>
        <p>{{dataVipMember.alamat}}</p><br>
        <p><b>Tanggal Lahir</b></p>
        <p>{{dataVipMember.tanggallahir}}</p><br>
      </div>

      <div class="col-12 col-md-12 p-4">
        <div class="row" style="place-content: center;">
          <div class="col-6 col-md-6">
            <p style="font-size: 10px !important; color: #999;">Apakah data diatas sudah benar?</p>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-12 pt-4 px-2">
        <div class="row">
          <div class="col-12 col-md-12 pb-2">
            <button class="btn btn-dark btn-sm bTcW col-8 rounded-pill" type="button" (click)="goToQ(dataVipMember.refid_otp,dataVipMember.hp,dataVipMember.no_client,false)">
              Sudah
            </button>
          </div>
          <div class="col-12 col-md-12">
            <button class="btn btn-dark btn-sm bTcW col-8 rounded-pill" type="button" (click)="goToQ(dataVipMember.refid_otp,dataVipMember.hp,dataVipMember.no_client,true)">
              Perbaharui data di akhir survey
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>


</div>
